<div class="h-full overflow-auto flex flex-col">
  <div class="flex justify-between p-4 text-xl font-bold items-center border-b">
    Ordini
  </div>

  <div class="h-full overflow-auto">
    <table>
      <thead class="sticky top-0 bg-gray-200 shadow">
        <tr>
          <th>#</th>
          <th>Cliente</th>
          <th>Stato</th>
          <th>Totale</th>
          <th>Spedizione</th>
          <th>Data</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @if (orders.isLoading()) {
          <tr><td colspan="7" class="p-6 text-gray-400">Caricamento...</td></tr>
        } @else if (!orders.value()?.data?.length) {
          <tr><td colspan="7" class="p-6 text-gray-400">Nessun ordine trovato.</td></tr>
        } @else {
          @for (order of orders.value()!.data; track order.id) {
            <tr [class.bg-gray-100]="$even" [class.bg-gray-200]="$odd">
              <td class="font-semibold">#{{ order.id }}</td>
              <td>{{ $any(order.address)['name'] }} {{ $any(order.address)['surname'] }}<br/><span class="text-xs text-gray-500">{{ $any(order.address)['email'] }}</span></td>
              <td>
                <span class="text-xs font-semibold px-2 py-1 rounded-full" [class]="statusClass(order.status)">
                  {{ statusLabel(order.status) }}
                </span>
              </td>
              <td>{{ order.total | currency : 'EUR' : '€ ' : '1.2-2' }}</td>
              <td>{{ order.shippingCosts | currency : 'EUR' : '€ ' : '1.2-2' }}</td>
              <td>{{ order.createdAt | date : 'dd/MM/yyyy HH:mm' }}</td>
              <td>
                <a wunButton primary [routerLink]="[order.id]">Dettaglio</a>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
